import React from 'react';
// Components
import HomePageHeader from '../../components/home/HomePageHeader';
import HomePageMainContainer from '../../components/home/HomePageMainContainer';
import FooterComponent from '../../components/footer/FooterComponent';

function HomePage() {
  return (
    <>
      <div className='grid min-h-screen bg-main-background'>
        <div className='grid h-full w-full'>
          {/* Header */}
          <HomePageHeader />

          <div>
            <HomePageMainContainer />
          </div>
          <div>
            <FooterComponent />
          </div>
        </div>
      </div>
    </>
  );
}

export default HomePage;
